import React from "react";

interface WaitStateBannerProps {
  waitStateData: any;
  waitLoading: boolean;
  resolveWaitState: (endpoint: any) => Promise<unknown>;
}

const WaitStateBanner = ({
  waitStateData,
  waitLoading,
  resolveWaitState
}: WaitStateBannerProps) => {
  if (!(waitStateData?.waitState || waitStateData?.failedState)) return null;

  return (
    <div className="mt-4">
      <div
        className="rounded-lg w-full p-4 flex flex-wrap md:flex-nowrap items-center justify-between"
        style={{
          background: waitStateData?.waitState ? "#fff3df" : "#ffe2e2",
          border:
            "1px dashed " + (waitStateData?.waitState ? "#cccccc" : "#bd8787")
        }}
      >
        <div className="w-full mb-1 md:mb-0 md:w-1/2">
          {waitStateData?.waitState && (
            <>
              <span
                className="font-semibold text-sm"
                style={{
                  color: "#df9c00"
                }}
              >
                Application in wait state
              </span>
              <br />
            </>
          )}
          {waitStateData?.reason && (
            <span
              className="text-xs font-medium"
              style={{
                color: waitStateData?.waitState ? "#a39075" : "#a75d5d"
              }}
            >
              {waitStateData?.reason}
            </span>
          )}
        </div>
        <div className="w-full md:w-1/2 flex items-center justify-end">
          {waitStateData?.suggestedAction && (
            <div
              className="text-xs"
              style={{
                color: waitStateData?.waitState ? "#91836e" : "#c54141"
              }}
            >
              {waitLoading
                ? "Pushing data to lender"
                : waitStateData?.suggestedAction}
              .
              {waitStateData?.suggestedActionType && (
                <button
                  className="block underline leading-6"
                  onClick={() =>
                    resolveWaitState(waitStateData?.suggestedActionType)
                  }
                >
                  {waitLoading ? "Loading..." : "Click here to retrigger"}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WaitStateBanner;
